import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'
import { TextWithIconTooltip } from 'common-components'
import { SMALL_MOBILE_HEIGHT } from '../consts'
import { COLORS } from 'consts/colors'

export const CustomTextWithIconTooltip = styled(TextWithIconTooltip)`
  padding: 20px 15px 10px;
`

export const TtsListWrapper = styled.div`
  padding: 0px 10px 8px 15px;
  height: 30%; //to apply initial approx height then ajust with flex-shrik and grow
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 10px;

  @media screen and (min-height: ${SMALL_MOBILE_HEIGHT}px) {
    overflow: hidden scroll;
    ${customizeVerticalScrollbarThumbMixin()}
  }
`

export const SkeletonWrapper = styled.div`
  width: 100%;
  height: 44px;
  position: relative;
  background-color: ${COLORS.primaryLight};
  border-radius: 6px;
`
